import React from 'react';
import Content from '../Components/Pages/Developer/Content';
import Header from '../Components/Shared/Header/Header';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function Developer(){
    return(
        <>
        <Header styles="scrolled"/>
        <Content />
        <Start />
        <Footer />
        </>
    )
};
export default Developer ;